import { useContext } from 'react'
import { CurrentMemberContext } from 'contexts/CurrentMemberContext'
import { getBrandingSettings } from 'utils/theming'
import Workspace from 'iam/models/Workspace'
import Member from 'iam/models/Member'
import { WorkspaceDTO } from 'iam/dtos/workspace'

export function useBrandingSettings() {
  const currentMember = useContext(CurrentMemberContext)

  let workspace: Workspace | WorkspaceDTO = Workspace.none
  if (
    window &&
    window.__workspaceDomain &&
    window.__workspaceDomain.workspace
  ) {
    workspace = window.__workspaceDomain.workspace
  }

  if (currentMember !== Member.none) {
    workspace = currentMember.workspace
  }

  const settings = getBrandingSettings(workspace)
  return settings
}
